import React from "react";
import { Container, Text, Link } from "./styled";

function MissingAppPanel({ text, link, linkText }) {
  return (
    <Container>
      <Text>{text}</Text>
      <Link href={link} target="_blank" rel="noreferrer">
        {linkText}
      </Link>
    </Container>
  );
}

export default MissingAppPanel;
